import { render, staticRenderFns } from "./CampusDialog.vue?vue&type=template&id=4cce2177"
import script from "./CampusDialog.vue?vue&type=script&lang=ts"
export * from "./CampusDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports